import React from "react";
import "./eonna.scss";
import data from "../../data.json";
import Heroc from "../../../component/hero/heroc.jsx";
import Aboutc from "../../../component/about/aboutc.jsx";
import Heroimages from "../../../asset/hero/heroimages.js";
import Promoc from "../../../component/promo/promoc.jsx";
import hsimages from "../../../asset/hardsell/hsimages.js";
import prmo from "../../../component/promo/promocard.json";
import Carouselfasc from "../../../component/carouselfas/carouselfasc.jsx";
import fas from "../../../component/carouselfas/carouselfasc.json";
import faseonna from "../../../asset/fascarousel/fas-eonna/fas-eonna.js";
import dataproduk from "../../../component/cardprodukdetail/cardprodukdetail.json";
import Cardprodukdetail from "../../../component/cardprodukdetail/cardprodukdetail.jsx";
import ScrollToHashElement from "../../home/ScrollToHashElement.js";
import imgAerra8 from "../../../asset/imgrumah/img-eonna/img-aerra/img-aerra8/img-aerra8.js";
import imgAerra9 from "../../../asset/imgrumah/img-eonna/img-aerra/img-aerra9/img-aerra9.js";
import imgAerra10 from "../../../asset/imgrumah/img-eonna/img-aerra/img-aerra10/img-aerra10.js";
import imgNamee8 from "../../../asset/imgrumah/img-eonna/img-namee/img-namee8/img-namee8.js";
import imgNamee9 from "../../../asset/imgrumah/img-eonna/img-namee/img-namee9/img-namee9.js";
const imgMap = {
  faseonna,
};
const imageMap = {
  imgAerra8,
  imgAerra9,
  imgAerra10,
  imgNamee8,
  imgNamee9,
};

const eonna = () => {
  return (
    <div className="eonna">
      <ScrollToHashElement />
      <div className="hero">
        {data.eonnaab.map((hero, index) => {
          // Determine the logo dynamically
          const fotopromo = Heroimages[hero.imagehero];
          return (
            <Heroc
              key={index}
              imagehero={fotopromo} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="about">
        {data.eonnaab.map((home, index) => {
          // Determine the logo dynamically
          return (
            <Aboutc
              key={index}
              judul={home.judul}
              subjudul={home.subjudul} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="container-promo">
        {prmo.Eonna.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = hsimages[promo.imagehs];
          return (
            <Promoc
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              details={promo.details}
              whatsappLink={promo.whatsappLink}
              quote={promo.quote} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="carouselfas">
        {fas.fasEonna.map((slide, index) => {
          return <Carouselfasc key={index} carousel={imgMap[slide.carousel]} />;
        })}
      </div>
      <div id="aerra" className="devider">
        <div className="a">AERRA</div>
      </div>
      <div className="produkcontainer">
        {dataproduk.Aerrap.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
      <div id="namee" className="devider">
        <div className="a">NAMEE</div>
      </div>
      <div className="produkcontainer">
        {dataproduk.Nameep.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
    </div>
  );
};

export default eonna;
